import { Box, Modal } from "@mui/material";
import { ModalStyle } from "../../helpers/appHelpers";
import { forceSignOut } from "../../services/utils/auth-interceptor";

interface SessionTimeoutModalProps {
	open: boolean;
	secondsRemaining: number;
	onContinue: () => void;
}

const SessionTimeoutModal = ({
	open,
	secondsRemaining,
	onContinue,
}: SessionTimeoutModalProps) => {
	return (
		<Modal
			open={open}
			aria-labelledby="session-timeout-title"
			aria-describedby="session-timeout-description"
			disableEscapeKeyDown
			onClose={(_event, reason) => {
				if (reason === "backdropClick") return;
			}}
		>
			<Box sx={{ width: 400, ...ModalStyle }}>
				<h2
					id="session-timeout-title"
					className="text-center font-bold text-lg mb-4"
				>
					Session Expiring
				</h2>
				<p id="session-timeout-description" className="text-center">
					You've been inactive. Your session will expire in{" "}
					<span className="font-bold">{secondsRemaining}</span> seconds.
				</p>

				<div className="flex w-full justify-center space-x-4 items-center mt-10 text-center whitespace-nowrap">
					<button
						onClick={() => forceSignOut()}
						className="w-full lg:w-fit lg:px-12 py-4 border text-gray-400 hover:text-gray-500 border-gray-300 rounded-lg text-2xs"
					>
						Log Out
					</button>
					<button
						onClick={onContinue}
						className="w-full lg:w-fit lg:px-12 py-4 border text-white hover:opacity-90 bg-primary-blue rounded-lg text-2xs"
					>
						Continue Session
					</button>
				</div>
			</Box>
		</Modal>
	);
};

export default SessionTimeoutModal;
